var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","color":"secondary","dark":""}},[_vm._v("Block Button")])}
var staticRenderFns = []

export { render, staticRenderFns }